var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/module-headline.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"moduleHeadline")) {
var t_1;
t_1 = (lineno = 2, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productMeta",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("isProduct", t_1, true);
if(frame.topLevel) {
context.setVariable("isProduct", t_1);
}
if(frame.topLevel) {
context.addExport("isProduct", t_1);
}
var t_2;
t_2 = (runtime.contextOrFrameLookup(context, frame, "isProduct")?"c-product-editorial":"c-landing-module");
frame.set("baseClass", t_2, true);
if(frame.topLevel) {
context.setVariable("baseClass", t_2);
}
if(frame.topLevel) {
context.addExport("baseClass", t_2);
}
output += "<div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12 ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseClass"), env.opts.autoescape);
output += "__header\">\n\n            <h2 class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseClass"), env.opts.autoescape);
output += "__title\" data-qa-module-headline>\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"moduleHeadline"), env.opts.autoescape);
output += "\n            </h2>\n\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "isProduct")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"linkText") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"linkUrl")) {
output += "<a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"linkUrl"), env.opts.autoescape);
output += "\" class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseClass"), env.opts.autoescape);
output += "__a\" data-qa-module-link>\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"linkText"), env.opts.autoescape);
output += "\n                    </a>";
;
}
output += "<hr class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseClass"), env.opts.autoescape);
output += "__hr\" />\n\n            ";
;
}
output += "\n\n        </div>\n\n    </div>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/module-headline.j2"] , dependencies)